/**
 * Canonical founder-facing Task sections.
 * Conversation and Task are separate pages that share one versioned draft.
 */

export const TASK_PRIMARY_SECTIONS = [
  { id: "conversation", label: "Conversation" },
  { id: "task", label: "Task" },
  { id: "engineering", label: "Engineering" },
  { id: "delivery", label: "Delivery" },
  { id: "review", label: "Review" },
];

export const TASK_SECONDARY_SECTIONS = [
  { id: "activity", label: "Activity" },
  { id: "sources", label: "Sources" },
  { id: "evidence", label: "Evidence" },
];

const ALIASES = {
  conversation: "conversation",
  task: "task",
  plan: "task",
  overview: "task",
  engineering: "engineering",
  handoff: "engineering",
  delivery: "delivery",
  review: "review",
  activity: "activity",
  sources: "sources",
  evidence: "evidence",
};

export function canonicalizeSection(section) {
  if (!section) return null;
  return ALIASES[String(section).toLowerCase()] || null;
}

export function isPrimarySection(section) {
  const id = canonicalizeSection(section);
  return TASK_PRIMARY_SECTIONS.some((item) => item.id === id);
}

export function currentActionSection(projection = {}) {
  return (
    canonicalizeSection(projection?.primaryAction?.section) ||
    canonicalizeSection(projection?.defaultSection) ||
    "task"
  );
}

export function sectionPathSegment(section) {
  const id = canonicalizeSection(section);
  return id || "conversation";
}

/**
 * Founder primary sections are always openable.
 * Earlier lifecycle stages show a waiting / next-step state inside the section
 * instead of disabling the tab (which made clicks feel broken).
 */
export function sectionAvailable(section, _projection = {}) {
  const id = canonicalizeSection(section);
  if (!id) return false;
  if (TASK_PRIMARY_SECTIONS.some((item) => item.id === id)) return true;
  return true;
}
